export const loadUserpanelLinksReducer = async () => {
	const module = await import("./modules/userpanel-links");
	return module.default;
};

export const loadUserpanelSettingsReducer = async () => {
	const module = await import("./modules/userpanel-settings");
	return module.default;
};

export const loadUserpanelFriendsReducer = async () => {
	const module = await import("./modules/userpanel-friends");
	return module.default;
};

export const loadUserpanelPostsReducer = async () => {
	const module = await import("./modules/userpanel-posts");
	return module.default;
};

export const loadUserpanelPhotosReducer = async () => {
	const module = await import("./modules/userpanel-photos");
	return module.default;
};

export const loadUserpanelVideosReducer = async () => {
	const module = await import("./modules/userpanel-videos");
	return module.default;
};

export const loadUserpanelNotificationsReducer = async () => {
	const module = await import("./modules/userpanel-notifications");
	return module.default;
};

export const loadUserpanelPaymentReducer = async () => {
	const module = await import("./modules/userpanel-payment");
	return module.default;
};

export const loadUserpanelMessagesReducer = async () => {
	const module = await import("./modules/messages");
	return module.default;
};

export const loadModalReducer = async () => {
	const module = await import("./modules/modal");
	return module.default;
};

export const loadServicePageSupportReducer = async () => {
	const module = await import("./modules/service-pages/support.slice");
	return module.default;
};
